import { API } from '@/api';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const createRtag = createAsyncThunk(
  'rtag/createRtag',
  async ({
    objective,
    region,
    spo,
    audience,
  }: {
    objective: string;
    region: string;
    spo: string;
    audience: string;
  }) => API.rtags.createRtag({ objective, region, spo, audience }),
);

export const retrieveRtag = createAsyncThunk('rtag/getRtag', async ({ jobId }: { jobId: string }) =>
  API.rtags.getRtag({ jobId }),
);
